import { API } from "../../../util/API";

// tslint:disable-next-line: no-unnecessary-class
export class CampaignDBService {
	static async sendEmailToDb(
		endpoint: string,
		email: string
	): Promise<{} | null> {
		const [response, error]: [{} | null, {} | null] = await API.postReq(
			endpoint,
			email
		);

		if (error) {
			console.warn(`Error in sending email to Database. Error: ${error}`);

			return null;
		}

		return response;
	}
}
